import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from "@angular/core";
import * as wjcSheet from "@grapecity/wijmo.grid.sheet";
import { UtilService } from "../../../services/util.service";
import { v4 as uuidv4 } from 'uuid';
import * as wjcGrid from '@grapecity/wijmo.grid';
import * as wjcCore from '@grapecity/wijmo';
import { template } from "ng-block-ui/components/block-ui-content/block-ui-content.component.template";
import { MatDialog } from "@angular/material/dialog";
import * as wjXlsx from "@grapecity/wijmo.xlsx";
// import * as wjcCore from "@grapecity/wijmo";
// import * as jszip from 'jszip';
// wjXlsx.useJSZip(jszip);


declare let $: any;

@Component({
  selector: "app-excel-viewer-output",
  templateUrl: "./excel-viewer-output.component.html",
  styleUrls: ["./excel-viewer-output.component.scss"],
})
export class ExcelViewerOutputComponent implements OnChanges {
  @Input() excelFile: any;
  @Input() isExtractionOutput = false;
  // add output property to emit changes excelFileChanged
  @Output() excelFileChanged = new EventEmitter<any>();
  // workbook: wjXlsx.Workbook;
  // sheetIndex: number;

  @ViewChild("flex") flex: wjcSheet.FlexSheet;
  showLoader = false;
  isFileLoaded = false;
  addNewRowColumns = []
  updatedRows = new Set<number>();  // track updated row indexes
  ngOnChanges(changes: SimpleChanges) {
    if(changes.excelFile && changes.excelFile.currentValue !== changes.excelFile.previousValue) {
      this.excelFile = changes.excelFile.currentValue;
      setTimeout(() => {
        this.loadDataViewer();
      }, 500);
    }
  }

  constructor(private utilService: UtilService, public dialog: MatDialog) {
  }

  loadDataViewer() {
    this.showLoader = true;
    const self = this;
    const gridId = 'grid-' + uuidv4(); 
    this.flex.hostElement.setAttribute('data-uuid', gridId);
    this.flex.loadAsync(
      this.excelFile,
      function (workbook) {
        // user can access the loaded workbook instance in this callback.
        //  self.loading = false;
        self.showLoader = false;
        self.isFileLoaded = true;
        if(self.isExtractionOutput) {
          const sheet = self.flex;
          sheet.autoSizeColumns();
          sheet.autoSizeColumns(sheet.frozenColumns, sheet.columns.length);
          sheet.columns[0].width = 100;  // Set width for the first column
          sheet.columns[1].width = 150;
        }
      },
      function (reason) {
        // User can catch the failure reason in this callback.
        console.log("The reason of load failure is " + self.excelFile);
        self.loadDataViewer();
        self.showLoader = false;
      }
    );
  }

  initializeFlexSheet(flex: wjcSheet.FlexSheet) {
    flex.deferUpdate(() => {
      if (flex) {
        flex.selectedSheetIndex = 0;
        flex.isReadOnly = false;
        // flex.allowResizing = 3;
        // flex.allowSorting = false;
        // flex.enableDragDrop = false;
        // flex.refreshOnEdit = false;
        // flex.autoSizeMode = 3;
        flex.allowAddNew = false;
        flex.lazyRender = false;
        flex.showSelectedHeaders = 0;
      }
    });
    if(this.isExtractionOutput) {
      let isInitialized = false;
      flex.selectedSheetChanged.addHandler((sender, args) => {
        if (!isInitialized) return;
          this.utilService.updateExcelSheetSelectionExtractionOutput.next({
            sheetIndex: sender.selectedSheetIndex, 
            sheetName: sender.selectedSheet.name,
            uuid: this.flex.hostElement.dataset.uuid 
          });
          // You can also perform other logic here
      });

      setTimeout(() => {
          isInitialized = true;
      }, 0);
    }
  }
  onSelectionChanged(s, event) {
    if(this.isFileLoaded) {
      const colCount = s.columns.length;

      const rowObject: { [key: string]: any } = {};
      const selectedRowIndex = s.selection.row;
      
      for (let col = 0; col < colCount; col++) {
        const key = s.getCellData(0, col, true); // header from row 0
        const value = s.getCellData(selectedRowIndex, col, true);
        rowObject[key] = value;
      }
      this.utilService.updateLeftExcelSheetRow.next({index: rowObject['UniqueRowIdentifier'],uuid:this.flex.hostElement.dataset.uuid});
    }
  }

  onCellEditEnded(e: any) {
    const rowIndex = e.row;
    this.updatedRows.add(rowIndex);
  }
  onFormatItem(e: any,dialogContentAddRow, s) {
  if(!this.isExtractionOutput) {
    return;
  }
  this.onFormatItemTooltip(s, e);
  const col = e.col;
  const row = e.row;
if (e.panel.cellType === wjcGrid.CellType.Cell) {
    if (this.updatedRows.has(row)) {
      e.cell.style.backgroundColor = '#e6f7ff'; // light blue
    } else {
      e.cell.style.backgroundColor = ''; // clear if not updated
    }
  }
  // Target only the first column (col index 0) and data cells (cellType 1 = Cell)
  if (e.panel.cellType === wjcGrid.CellType.Cell && col === 0 && row !== 0) {
    // Avoid duplicating icons
    if (!e.cell.querySelector('.edit-icon')) {
      const icon = document.createElement('span');
      icon.className = 'edit-icon material-icons';
      icon.innerText = 'edit'; // or use 'mode_edit'
      e.cell.style.position = 'relative';
      Object.assign(icon.style, {
        position: 'absolute',
        right: '6px',
        top: '50%',
        transform: 'translateY(-50%)',
        fontSize: '18px',
        color: '#0063b5',  // or '#00bfff' for stronger blue
        cursor: 'pointer',
        zIndex: '10'
      });
      icon.addEventListener('click', (event) => {
        const colCount = s.columns.length;

      const rowObject: { [key: string]: any } = {};
      const selectedRowIndex = s.selection.row;
      
      for (let col = 0; col < colCount; col++) {
        const key = s.getCellData(0, col, true); // header from row 0
        const value = s.getCellData(selectedRowIndex, col, true);
        rowObject[key] = value;
      }
        this.editRow(dialogContentAddRow, row, rowObject);
      });
      e.cell.appendChild(icon);
    }
  }
}
editRow(template, row, rowObject) {
  this.addNewRowColumns = [];
  this.addNewRowColumns = Object.keys(rowObject).map(key => {
    return { key: rowObject[key], label: key };
  }); 
  this.dialog.open(template, {
      panelClass: "extraction-summary-dialog",
      width: '50%',
      data: {},
      disableClose: true,
    });
}
updateRow() {
  if(!this.addNewRowColumns || this.addNewRowColumns.length === 0) {
    return;
  }
  //update the row in the flex sheet with the new values in the selected row
  const selectedRowIndex = this.flex.selection.row;  
  this.addNewRowColumns.forEach((item, index) => {
    this.flex.setCellData(selectedRowIndex, index, item.key);
  }); 
  this.excelFileChanged.emit(this.flex);
  this.dialog.closeAll();
}
onFormatItemTooltip(s, e) {
    let tt = new wjcCore.Tooltip();
    if(e.panel.cellType == wjcGrid.CellType.Cell){
      const val = s.getCellData(e.row, e.col, false);
      tt.setTooltip(e.cell, val ? val.toString() : '');
    }
  }
}
